import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";

const SEND_TERMS_AND_CONDITIONS_TO_EMAIL_MUTATION = gql(`
mutation sendTermsAndConditionsToEmail($offerId: String!) {
  sendTermsAndConditionsToEmail(id: $offerId)
}
`);

export function useSendTermsAndConditionsToEmail() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation(SEND_TERMS_AND_CONDITIONS_TO_EMAIL_MUTATION);
  const sendTermsAndConditionsToEmail = async () => {
    const { data } = await mutation({
      variables: { offerId },
    });
    return data;
  };
  return [sendTermsAndConditionsToEmail, info] as const;
}
